/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cloud_download_medium'
export default icon
